import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { NSDLBank3SenderRegitartion as SENDER_ADD } from 'Components/Api/NovityDMTAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import { useLocation } from 'react-router-dom';
import usePosition from 'Components/Posistion';
import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const NSDLBankSenderAdd = () => {
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const Mobile = location?.state?.Mobile;
    const AdharNo = location?.state?.AdharNo;
    const BankPipe = location?.state?.BankPipe;
    const ActiveDMTName = location?.state?.DMTName;
    const { latitude, longitude } = usePosition();
    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        AdharNo: AdharNo,
        Latitude: latitude,
        Longitude: longitude,
        Name: '',
        Pincode: '',
        CityName: '',
        DMTName: ActiveDMTName,
        BankPipe: BankPipe
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }

        values.DMTName = ActiveDMTName;
        values.Latitude = latitude;
        values.Longitude = longitude;
        var requestObj = JSON.stringify(values);
        setLoading(true);
        setIsError(false);

        var response = await SENDER_ADD(requestObj);
        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            setLoading(false);
            return;
        }
        resetForm(formObject);
        if (response.data === 'OTP Generated Successfully') {
            var param = {
                Mobile: Mobile,
                AdharNo: AdharNo,
                DMTName: ActiveDMTName,
                BankPipe: BankPipe
            };
            history.push('/NTDMT_NSDLBankSenderOTPVerify', param);
            return;
        }
        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);

        var param_2 = {
            Mobile: values.Mobile,
            DMTName: ActiveDMTName,
            BankPipe: BankPipe
        };
        history.push('/NTDMT_SenderSearch', param_2);
    };

    const select = () => {
        setFormObject({
            ...formObject,
            Mobile: Mobile,
            BankPipe: BankPipe,
            Name: ''
        });
    };

    useEffect(() => {
        select();
    }, []);

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
        Name: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'first name')
            .min(4, PLEASE_PROVIDE_VALID + 'aleast 4 length name'),

        Pincode: Yup.string()
            .length(6, 'Must be 6 digit')
            .required(PLEASE_PROVIDE_VALID + 'pincode')
    });
    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue }) => {
                    return (
                        <Form>
                            <h2
                                className={classes.PaperHead_h2}
                                style={{
                                    marginBottom: '16px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                NSDL Bank Sender Add{' '}
                                <b style={{ marginLeft: '100px' }}>BankPipe</b>:{' '}
                                {BankPipe}{' '}
                            </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                label="Mobile"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                readOnly={true}
                                                placeholder="Mobile"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Full Name"
                                                name="Name"
                                                type="text"
                                                placeholder="Full Name"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                label="Pin code"
                                                name="Pincode"
                                                type="text"
                                                length={6}
                                                title="Pin code"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="City Name"
                                                name="CityName"
                                                type="text"
                                                placeholder="City Name"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box
                                    className={classes.flexReverse}
                                    sx={{ gap: '16px' }}
                                >
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Add"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loading}
                                        >
                                            Add
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                    <Button
                                        variant="contained"
                                        style={{
                                            backgroundColor: '#D5006D',
                                            color: 'white',
                                            width: '60px',
                                            marginLeft: '16px'
                                        }}
                                        onClick={() => {
                                            history.push(
                                                '/NTDMT_NSDLBank3SenderAdharVerifyEKYC',
                                                {
                                                    Mobile: Mobile,
                                                    BankPipe: BankPipe,
                                                    DMTName: ActiveDMTName,
                                                    Name: ''
                                                }
                                            );
                                        }}
                                    >
                                        Back
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            />
        </CustomContainer>
    );
};
